/*
 * @Author: yindengli
 * @Date: 2023-06-26 11:04:28
 * @LastEditTime: 2023-10-11 10:33:12
 * @LastEditors: yindengli
 * @Description: 
 * @FilePath: \openseeyon-index-front\src\router\index.js
 */

import Vue from 'vue'
import VueRouter from 'vue-router'
import { getTokenByUuid } from '@/api/index.js';
import { setCookie } from "@/utils/common";
import eventBus from '@/utils/eventBus';
import Home from '../components/Home'
import FaqPage from '../components/FaqCmp/Faq'
// import FaqDetail from '../components/FaqCmp/detail/DetailModal'
import Document from '../components/Document'
import ToolsBase from '../components/toolsBaseCmp/ToolsBase'
import UpdateLog from '../components/updateLog/updateLog'
import Login from '../components/login/Login'

import SendQuestion from '../components/sendQuestion'

import OfficePlugin from '../components/OfficePlugin/index.vue'

const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter);
const routes = [
    {
        name: 'home',
        path: '/home',
        component: Home
    }, {
        name: 'faq',
        path: '/faq',
        component: FaqPage
    }, {
        name: 'doc',
        path: '/doc',
        component: Document
    }, {
        name: 'toolbase',
        path: '/toolbase',
        component: ToolsBase
    }, {
        name: 'projects',
        path: '/projects'
    }, {
        name: 'forum',
        path: '/forum'
    }, 
    {
        name: 'detail',
        path: '/faq/:faq*',
        redirect: '/faq'
    },
    {
        name: 'updateLog',
        path: "/updateLog",
        component: UpdateLog
    }, {
      name: 'login',
      path: "/login",
      component: Login
    }, {
        name: 'sendQuestion',
        path: "/sendQuestion",
        component: SendQuestion
    },{
      name: 'officePlugin',
      path: "/officePlugin",
      component: OfficePlugin
  },{
    path: '*',
    redirect: '/home'
  }
]
const router = new VueRouter({
    //mode: 'history',
    //base: '/dist/',
    routes
})
router.beforeEach((to, from, next) => {
    console.log(to, from, next)
    if(to.query.uuid){
        getTokenByUuid({uuid: to.query.uuid}).then(res=>{
            if(res.code == 200){
                const {token} = res.data
                setCookie("loginKey", token);
                eventBus.$emit("loginSuccess", false);
            }
        }).finally(()=>{
            next(to.path)
        })
    }else{
        next()
    }
})
export default router